import { Text, VStack } from '@frontend/legacy-components';

export const PersonCellContent = ({
  firstName,
  lastName,
}: {
  firstName?: string;
  lastName?: string;
}): React.ReactElement => (
  <VStack spacing={0} alignItems="stretch">
    <Text as="span" textAlign="inherit">
      {[firstName, lastName].join(' ')}
    </Text>
  </VStack>
);
